import React from 'react'
import { useTranslation } from 'i18n'
import { Button } from '@arvoreeducacao/bonsai-ds'
import { getImageUrl } from 'utils/assets/Cdn'
import {
  PRIVACY_POLICY_PDF,
  TERMS_OF_USE_PDF
} from 'components/payment-form/constants'
import { LOGOUT_PATH } from 'routes/paths'
import { post_event } from 'utils/analytics'
import { getSuperAutorUrl } from 'components/modular/tabs-home/constants'

interface InactiveContractProps {
  hasCriarModuleAndFlag?: boolean
}

const InactiveContract: React.FC<InactiveContractProps> = ({
  hasCriarModuleAndFlag = false
}) => {
  const { t } = useTranslation()

  const onClickFooterLink = (link: string) => {
    post_event('inactive_contract_footer_link_click', { link })
  }

  const onClickBackToLogin = () => {
    window.location.href = LOGOUT_PATH
  }

  return (
    <div className="flex min-h-dvh w-dvw justify-center items-start md:items-center bg-gradient-to-t from-[#44b0c1]/30 to-white">
      <div className="flex flex-col md:flex-row md:items-center">
        <div className="mx-auto w-[94%] max-md:px-4">
          <div className="mt-10 mb-4 md:fixed md:left-10 md:top-10 md:mt-0 md:z-10">
            <Button
              ghost
              iconName="arrow-left"
              isLeft
              onClick={onClickBackToLogin}
            >
              {t('Voltar para login')}
            </Button>
          </div>

          <div className="flex w-full flex-col items-center gap-10 md:mx-auto md:w-[850px] md:gap-14">
            <section className="mt-4 flex w-full max-w-[600px] flex-col items-center justify-center bg-white p-6 text-center md:mt-8 md:rounded-[10px] md:border md:border-solid md:border-[#dfe5e9] md:p-8 md:shadow-[0_12px_17px_2px_rgba(0,0,0,0.06)]">
              <h2 className="m-0 mb-4 text-[24px] font-bold text-[#2d2d2e]">
                {t('Acesso indisponível no momento')}
              </h2>
              <p className="my-2 max-w-[420px] text-[16px] leading-[1.6] text-[#595a5c]">
                {t(
                  'No momento, o acesso ao acervo de leitura não está disponível para a sua conta.'
                )}{' '}
                <strong>
                  {t(
                    'Entre em contato diretamente com a sua coordenação escolar'
                  )}
                </strong>
                {t(' para mais informações.')}
              </p>
            </section>

            {hasCriarModuleAndFlag && (
              <section className="flex w-full max-w-[600px] flex-col items-center justify-center rounded-[10px] border border-solid border-[#dfe5e9] bg-[#f9fafb] px-6 py-5 text-center">
                <h2 className="m-0 mb-1 !text-[17px] font-bold text-[#2d2d2e]">
                  {t('Portal de Criação')}
                </h2>
                <p className="m-0 max-w-[280px] !text-[12px] leading-[1.4] text-[#595a5c]">
                  {t(
                    'No SuperAutor, alunos escrevem e ilustram seus próprios livros — e lançam em um evento de autógrafos.'
                  )}
                </p>
                <a
                  href={getSuperAutorUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 w-full rounded-[8px] border border-solid border-[#dfe5e9] bg-white px-4 py-2 text-center !text-[12px] font-bold text-[#2d2d2e] no-underline transition-colors hover:bg-[#f3f4f6]"
                >
                  {t('Acessar SuperAutor')}
                </a>
                <p className="m-0 mt-2 max-w-[280px] !text-[10px] italic leading-[1.4] text-[#9eaeb7]">
                  {t(
                    'O SuperAutor é uma plataforma de escrita e não dá acesso ao acervo de leitura da Árvore.'
                  )}
                </p>
              </section>
            )}
          </div>

          <footer className="mt-10 mb-10 grid justify-items-center text-center text-[13px]">
            <div className="flex w-full justify-center">
              <a
                onClick={() => onClickFooterLink(PRIVACY_POLICY_PDF)}
                href={PRIVACY_POLICY_PDF}
                target="_blank"
                rel="noopener noreferrer"
                className="mr-5 text-[13px] text-[#9eaeb7]"
              >
                Política de privacidade
              </a>
              <a
                onClick={() => onClickFooterLink(TERMS_OF_USE_PDF)}
                href={TERMS_OF_USE_PDF}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[13px] text-[#9eaeb7]"
              >
                Termo de uso
              </a>
            </div>
            <div className="mt-5 leading-[23px] text-[#9eaeb7]">
              Árvore Livros Comércio Distribuição e Serviços SA - CNPJ <br />
              19.004.863/0001-65 - Rua Sacadura Cabral 144 - Rio de Janeiro - RJ
            </div>
            <img
              alt="Árvore Livros"
              className="my-5"
              src={getImageUrl('logos/logo-arvore.svg')}
            />
          </footer>
        </div>
      </div>
    </div>
  )
}

export default InactiveContract
